import React from 'react';
import { Button, Modal } from 'react-bootstrap';

function PopUpModal(props) {
  return (
    <div>
      <Modal show={props.deleteShow} onHide={props.handleClose}>
        <Modal.Body>Are you sure you want to delete this {props.deleteText} ?</Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={props.handleClose}>
            No
          </Button>
          <Button variant='primary' onClick={props.deleteObject}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PopUpModal;
